export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative bg-fx-navy text-white overflow-hidden">
      <div className="absolute inset-0">
        {image && <img src={image} alt="" className="w-full h-full object-cover opacity-35" />}
        <div className="absolute inset-0 bg-gradient-to-r from-fx-navy via-fx-navy/90 to-fx-navy/70" />
        <div className="fx-grain" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
        {eyebrow && <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">{eyebrow}</p>}
        <h1 className="font-display text-4xl lg:text-6xl font-bold mt-3 max-w-3xl leading-tight">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-white/80 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
